export enum SendGiftCardTypeEnum {
  ForMe = 1,
  ForSomebodyElse = 2,
}
